import createIcon from '../../createIcon';

/**
 * @component @name Accessible
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNkMxMy4xMDQ2IDYgMTQgNS4xMDQ1NyAxNCA0QzE0IDIuODk1NDMgMTMuMTA0NiAyIDEyIDJDMTAuODk1NCAyIDEwIDIuODk1NDMgMTAgNEMxMCA1LjEwNDU3IDEwLjg5NTQgNiAxMiA2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5IDEzVjExQzE3LjQ2IDExLjAyIDE1LjkxIDEwLjI1IDE0LjkzIDkuMTdMMTMuNjQgNy43NEMxMy40NyA3LjU1IDEzLjI2IDcuNCAxMy4wMyA3LjI5QzEzLjAyIDcuMjkgMTMuMDIgNy4yOCAxMy4wMSA3LjI4SDEzQzEyLjY1IDcuMDggMTIuMjUgNi45OCAxMS44MSA3LjAyQzEwLjc2IDcuMTEgMTAgOC4wNCAxMCA5LjA5VjE1QzEwIDE2LjEgMTAuOSAxNyAxMiAxN0gxN1YyMkgxOVYxNi41QzE5IDE1LjQgMTguMSAxNC41IDE3IDE0LjVIMTRWMTEuMDVDMTUuMjkgMTIuMTIgMTcuMjUgMTIuOTkgMTkgMTNaTTEyLjgzIDE4QzEyLjQyIDE5LjE2IDExLjMxIDIwIDEwIDIwQzguMzQgMjAgNyAxOC42NiA3IDE3QzcgMTUuNjkgNy44NCAxNC41OSA5IDE0LjE3VjEyLjFDNi43MiAxMi41NiA1IDE0LjU4IDUgMTdDNSAxOS43NiA3LjI0IDIyIDEwIDIyQzEyLjQyIDIyIDE0LjQ0IDIwLjI4IDE0LjkgMThIMTIuODNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Accessible = createIcon('Accessible', [
  [
    'path',
    {
      d: 'M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z',
      key: '1cb55s',
    },
  ],
  [
    'path',
    {
      d: 'M19 13V11C17.46 11.02 15.91 10.25 14.93 9.17L13.64 7.74C13.47 7.55 13.26 7.4 13.03 7.29C13.02 7.29 13.02 7.28 13.01 7.28H13C12.65 7.08 12.25 6.98 11.81 7.02C10.76 7.11 10 8.04 10 9.09V15C10 16.1 10.9 17 12 17H17V22H19V16.5C19 15.4 18.1 14.5 17 14.5H14V11.05C15.29 12.12 17.25 12.99 19 13ZM12.83 18C12.42 19.16 11.31 20 10 20C8.34 20 7 18.66 7 17C7 15.69 7.84 14.59 9 14.17V12.1C6.72 12.56 5 14.58 5 17C5 19.76 7.24 22 10 22C12.42 22 14.44 20.28 14.9 18H12.83Z',
      key: 'r672ex',
    },
  ],
]);

export default Accessible;
